<div class="flex flex-col h-full w-full justify-start items-start gap-6 pb-6 bg-[#FFF]">
  <app-loi-check-stepper #stepper (selectedStepChange)="navigateToBaseCheckReport()" [nextStepAllowed]="true"
                         [previousStepAllowed]="true"
                         [selectedStep]="1"
                         class="w-full"></app-loi-check-stepper>

    <div class="w-full px-6">
      <app-overview-reports (download)="downloadReport()"
                            (open)="openPressed()"
                            [activateDownload]="!loading"
                            [activateOpen]="!loading"
                            [checkerName]="checkerName"
                            [completedValue]="medianOfPercentages()"
                            [date]="check.checkDate"
                            [fileId]="check.projectFile?.id ?? ''"
                            [info1]="fileSize"
                            [info2]="fileName"
                            [rules]="ruleName"
                            [loading]="loading"
                            checkType="LOI"
                            class="w-full">
      </app-overview-reports>
    </div>
    <div class="flex w-full flex-1 min-h-0 overflow-hidden px-6">
      <bic-result>
        <bic-result-column #rulesColumn [(selectedElement)]="selectedRule" [alwaysFixed]="true"
                           [style.flex]="'50 1 0%'" [style.max-width]="'100%'" [style.min-width]="'0'">
          <bic-result-header header>
            <div class="w-full flex flex-row justify-between items-center gap-4 pr-8">
              <div class="w-[50px] text-center flex-shrink-0">
                Status
              </div>
              <div class="flex-1 min-w-0">
                Bauteiltyp
              </div>
              <div class="w-32 text-center flex-shrink-0">
                Anzahl Bauteile
              </div>
              <div class="w-32 text-center flex-shrink-0">
                Ergebnis
              </div>
            </div>
          </bic-result-header>

          @if (loading) {
            <bic-result-row [disableTasks]="true" [hidden]="true"></bic-result-row>
            <div class="flex flex-col flex-1 h-full justify-center items-center py-16">
              <div class="flex flex-row items-center gap-2">
                <fa-icon [icon]="faSpinnerThird" class="text-gray-500 animate-spin text-svg-16"></fa-icon>
                <span class="text-sm font-medium text-gray-500">Ergebnisse werden geladen...</span>
              </div>
            </div>
          } @else {
            @for (rule of rulesOfSelectedProjectFile; track rule) {
              <bic-result-row (taskClicked)="createTaskForRuleAndSelectedFile(rule)"
                              [status]="statusForRuleAndSelectedFile(rule)"
                              [value]="rule">
                <div class="w-full flex flex-row justify-between items-center gap-4">
                  <div class="flex-1 min-w-0">
                    {{ rule.name }}
                  </div>

                  <div class="w-32 text-center flex-shrink-0">
                    {{ countForRuleAndSelectedFile(rule) }}
                  </div>

                  <div class="w-32 text-center flex-shrink-0">
                    {{ resultPercentageForRuleAndSelectedFile(rule) }} %
                  </div>
                </div>
              </bic-result-row>
            }
          }
        </bic-result-column>
        <bic-result-column [grouped]="true" [style.flex]="'50 1 0%'"
                           [style.max-width]="'100%'" [style.min-width]="'0'" emptyText="Bitte Prüfregel auswählen">
          <bic-result-header header>
            <div class="w-full flex flex-row justify-between min-w-0 items-center gap-4">
              <div class="w-[50px] text-center flex-shrink-0">
                Status
              </div>

              <div class="flex-1 min-w-0">
                Erforderliche Attribute
              </div>

              <div class="w-32 text-center flex-shrink-0">
                Ergebnis
              </div>
            </div>
          </bic-result-header>

          @if (selectedRule) {
            @for (result of resultOfSelectedProjectFileAndSelectedRule; track $index) {
              <bic-result-row (taskClicked)="createTaskForProperty(result)"
                              [status]="result.type" [grouped]="true">
                <div class="w-full flex flex-row justify-between items-center gap-4">
                  <div class="flex-1 min-w-0 truncate">
                    {{ result.responseText }}
                  </div>

                  <div class="w-32 text-center flex-shrink-0">
                    {{ result.percentage }} %
                  </div>
                </div>
              </bic-result-row>
            }
          }
        </bic-result-column>
      </bic-result>
    </div>

</div>
